import { useEffect,useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { IPerformanceCompetencies } from '../../../interfaces/PerformanceEvaluationQualification.interface';
import CheckboxQualification from './CheckboxQualification';
import { Grid } from '@material-ui/core';

type InfoCompetencesQualificationProps ={
  competencia:IPerformanceCompetencies,
  qualPerfEval:any,
  addQualification:(event:any,idCompetencies:number)=> void  
  disabledFunc:boolean
}

const options = [
  {  idQual:1, qualification:"Deficiente", description:"Muy inferior al esperado. Necesita mucho apoyo." },
  {  idQual:2, qualification:"Básico",  description:"Cumple lo mínimo, pero necesita mejorar."  },
  {  idQual:3, qualification:"Intermedio", description:"Adecuado en la mayoría de los aspectos. Aún puede mejorar."  },
  {  idQual:4, qualification:"Avanzado",  description:"Supera los estándares en varios aspectos. Competente" },
  {  idQual:5, qualification:"Sobresaliente",  description:"Excepcional en todos los aspectos. Dominio excelente" },
];

 const InfoCompetencesQualification = ({competencia,qualPerfEval,addQualification,disabledFunc}:InfoCompetencesQualificationProps) => {
  const {DescriptionCompetence,nameCompetence,idCompetencies,idQual}=competencia
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedIdComp, setSelectedIdComp] = useState<number | null>(null);  
  const[isDisabled,setIsDisabled]= useState<boolean>(false);
  
  useEffect(() => {
    if(disabledFunc){
      setIsDisabled(true)  
    }
    if(qualPerfEval.length >0){    
      setSelectedId(idQual)
      setSelectedIdComp(idCompetencies)
    }else{
      if(idCompetencies !== null && idQual!== null){
        setSelectedId(idQual)
        setSelectedIdComp(idCompetencies)
        setIsDisabled(true)
      }
    }
  }, [disabledFunc, idCompetencies, idQual, qualPerfEval]);

 console.log(qualPerfEval) 
const isOptionChecked = (opt:any, idCompetencies:any) => {
  const res= qualPerfEval.some(
      (qual:any) => parseInt(qual.idQual) === parseInt(opt.idQual) && qual.idCompetencies === idCompetencies && qual.checked
  );    
  return res;
};
   return (
    <Grid className="containerInfoCompetences"> 
      <div className='headerCompetencia'> 
        <div className="containerTitleCompetence"><span className="titleCompetence">{nameCompetence}</span> </div>  
        <div className="vertical-line-Competence"></div>
        <div className="containerDescriptionCompetence"><span className="descriptionCompetence">{DescriptionCompetence}</span> </div>  
      </div>
      <div className='containerQuestionsCompetences'>
          { options.map((opt: any) => {
            return (
               <CheckboxQualification
                key={uuidv4()}                            
                option={opt}                  
                addQualification={addQualification}
                idCompetencies={idCompetencies}                                     
                isChecked={qualPerfEval.length >0?isOptionChecked(opt, idCompetencies):(selectedId === opt.idQual && selectedIdComp=== idCompetencies)  }                              
                disabled={isDisabled}
            />                             
            )
          })
        } 
             
      </div>
    </Grid>
  )
}

export default InfoCompetencesQualification